export default __webpack_public_path__ + "static/media/STL_Annual_Return_2024.fb15016f.pdf";